import DialogComponent from "components/Dialog";

import { ReactComponent as ArrowRightSIcon } from 'icons/components/arrowRightS.svg';

import './themes/default.less';
import './index.less';

export default class newFundDialog extends DialogComponent {

    constructor(props) {
        super(props);

        this.transactionTypes = [
            { value: 0, name: "expenses.incoming" },
            { value: 1, name: "expenses.spending" },
            { value: 2, name: "expenses.collection" },
        ];

        this.state = {
            ...this.state,
            isCreateMode: true,
            type: false
        };
    }

    title = "expenses.newFundraising";

    show() {
        super.show();
    }

    async save() {
        //save
    }

    onModeChange(mode) {
        this.changeState("isCreateMode", mode);
    }

    onChangeComment(value) {
        
    }

    renderMovement() {
        const { type } = this.state;

        return (<>
            {this.insertSelect({
                value: type,
                label: "invoice.transactionType",
                showLeftIcon: false,
                translate: true,
                placeHolder: "main.notIndicated",
                items: this.transactionTypes,
                onChange: this.changeState.bind(this, "type"),
            })}
            <div className="flex gap8">
                <div className="flex1">
                    {this.insertSelectDate({
                        ref: el => this.selectDateCalendar = el
                    })}
                </div>
                <div className="flex1">
                    {this.insertSumInput({
                        label: "main.sum"
                    })}
                </div>
            </div>
            {this.insertTextarea({
                label: "expenses.commentOperation",
                placeHolder: "main.freeComment",
                onChange: this.onChangeComment.bind(this)
            })}
        </>);
    }

    renderCalculation() {
        return (<div className="flex between w100">
            <div className="flex1 flex col gap8">
                <div className="titleCalc text p2">
                    {this.tr("expenses.was")}
                </div>
                <div className="valCalc text p1">
                    9 966,57 ₽
                </div>
            </div>
            <div className="arrowCalc flex col gap16 centerH">
                <div></div>
                <ArrowRightSIcon />
            </div>
            <div className="flex1">
                {this.insertSumInput({
                    label: "expenses.will",
                    placeHolder: "9 966,57",
                    readonly: true,
                })}
            </div>
        </div>);
    }

    renderAdjustment() {
        return (<>
            <div className="flex1 flex col gap16">
                <div className="flex">
                    <div className="flex1">
                        {this.insertSelectDate({
                            ref: el => this.selectDateCalendar = el
                        })}
                    </div>
                    <div className="flex1"></div>
                </div>
                {this.insertLine()}
                {this.insertParagraf("expenses.balanceBeginning")}
                {this.renderCalculation()}
                {this.insertLine()}
                {this.insertParagraf("expenses.balanceEnd")}
                {this.renderCalculation()}
                {this.insertLine()}
                {this.insertTextarea({
                    label: "expenses.commentOperation",
                    placeHolder: "main.freeComment",
                    onChange: this.onChangeComment.bind(this)
                })}
            </div>
        </>);
    }

    renderContent() {

        const { isCreateMode } = this.state;

        return (
            <div className="newFundDialog content text p1 flex col gap16">
                <div className="flex">
                    {this.insertToggleButtons({
                        active: isCreateMode,
                        labels: ["expenses.movement", "expenses.balanceAdjustment"],
                        values: [true, false],
                        onChange: this.onModeChange.bind(this),
                        value: isCreateMode
                    })}
                </div>
                {isCreateMode ? this.renderMovement() : this.renderAdjustment()}
            </div>
        );
    }
}
